import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from "react-router-dom";
import { useSelector } from 'react-redux';
import { FontAwesomeIcon as Icon } from '@fortawesome/react-fontawesome';
import { faPlus } from '@fortawesome/free-solid-svg-icons';
import Form from '../common/Form';
import Pager from '../common/Pager';
import useApiList from '../../hooks/useApiList';
import getLogo from '../../utils/getLogo';
import { PAGE_LIMIT } from '../../config';

const EventList = () => {
	const limit = PAGE_LIMIT;
	const navigate = useNavigate();
	const { t, i18n } = useTranslation();
    const lang = i18n.language;
	const auth = useSelector(state => state.auth.user);
	const [ find, setFind ] = useState('');
	const [ skip, setSkip ] = useState(0);
	const [ archived, setArchived ] = useState('');
	// eslint-disable-next-line
	const [ admin, setAdmin ] = useState(auth?.role === 'admin' ? auth?._id : null);
	// eslint-disable-next-line
	const [ method, setMethod ] = useState(auth?.role === 'admin' ? '/eventsbyadmin' : '/events');
	const [ data, error, isLoading ] = useApiList({ method, limit, find, skip, admin, archived });

	useEffect(() => {
		setSkip(0);
	}, [ find, archived ]);

	return (
		<div>
	    	<h1>{t('eventlist.title')}</h1>
			<Form error={error}>
				<div className='Form-row'>
					<input
						type='text'
						value={find}
						placeholder={t('eventlist.placeholder')}
						onChange={e => setFind(e.target.value)}
					/>
					<div
						className='submit'
						onClick={() => navigate('/cabinet/eventadd')}
					>
						<Icon icon={faPlus}/>
					</div>
				</div>
                <fieldset id='is_archived'>
					<input
                        id='radioActual'
                        type='radio'
                        value=''
                        name='archived'
                        checked={archived !== 'true'}
                        onChange={() => setArchived('')}
                    />
                    <label htmlFor='radioActual'>{t('eventlist.actual')}</label>
                    <input
                        id='radioArchived'
                        type='radio'
                        value='true'
                        name='archived'
                        checked={archived === 'true'}
                        onChange={() => setArchived('true')}
                    />
                    <label htmlFor='radioArchived'>{t('eventlist.archived')}</label>
                </fieldset>
			</Form>

			{isLoading ? <span>{t('common.loading')}</span> :
			<React.Fragment>
				{data &&
				<React.Fragment>
					<div>
						{data.total ? t('eventlist.found') + data.total : t('eventlist.notfound')}
					</div>
					<div className='list'>
					{data.events.map(event => (
						<div
							key={event._id}
							className='item'
							onClick={() => navigate('/cabinet/eventview/' + event._id)}
						>
							<img alt='icon' className='icon' src={getLogo(event)}/>
							<div className='text'>{event.name[lang]}</div>
						</div>
					))}
					</div>
					<Pager total={data.total} skip={skip} limit={limit} setSkip={setSkip}/>
				</React.Fragment>}
			</React.Fragment>}

			{(auth?.role === 'root' && !archived) && <Form>
				<input
					type='submit'
					value={t('eventlist.eventadd')}
					onClick={() => navigate('/cabinet/eventadd')}
				/>
			</Form>}
		</div>
	);
};

export default EventList;
